export const SET_SHOW_CONNECTION_INDICATOR = 'SET_SHOW_CONNECTION_INDICATOR';
export const SET_WARN_ON_MOBILE_DATA = 'SET_WARN_ON_MOBILE_DATA';
